import _ from 'lodash';

export const selectPropertyForm = state => _.get(state, ['propertyForm'], {});

export const selectPropertyFormData = state => _.get(selectPropertyForm(state), ['data'], {});
